// Lista oficial das Subseções/Seccionais da OAB (ID + nome), extraída pelo usuário direto
// da tabela SubUnidadeConselho do banco — usada nos campos de "Subseção da Inscrição/
// Sociedade" e "Seccional de Origem" dos pedidos de Requerimentos. O "value" é o ID de
// registro nessa tabela, que a API de Protocolo espera nos campos SubUnidadeAtual/
// SubUnidadeOrigem em DadosRequerimento (ver dadosRequerimentoService.js).
export const SUBUNIDADES_OAB_MS = [
  { value: '11', label: 'AMAMBAÍ' },
  { value: '23', label: 'APARECIDA DO TABOADO' },
  { value: '3', label: 'AQUIDAUANA' },
  { value: '20', label: 'BATAGUASSU' },
  { value: '26', label: 'BELA VISTA' },
  { value: '24', label: 'BONITO' },
  { value: '29', label: 'CAARAPÓ' },
  { value: '15', label: 'CAMAPUÃ' },
  { value: '50', label: 'CAMPO GRANDE' },
  { value: '13', label: 'CASSILÂNDIA' },
  { value: '28', label: 'CHAPADÃO DO SUL' },
  { value: '1', label: 'CORUMBÁ' },
  { value: '17', label: 'COSTA RICA' },
  { value: '10', label: 'COXIM' },
  { value: '4', label: 'DOURADOS' },
  { value: '16', label: 'FÁTIMA DO SUL' },
  { value: '31', label: 'IGUATEMI' },
  { value: '19', label: 'IVINHEMA' },
  { value: '12', label: 'JARDIM' },
  { value: '14', label: 'MARACAJU' },
  { value: '30', label: 'MIRANDA' },
  { value: '27', label: 'MUNDO NOVO' },
  { value: '9', label: 'NAVIRAÍ' },
  { value: '8', label: 'NOVA ANDRADINA' },
  { value: '7', label: 'PARANAÍBA' },
  { value: '32', label: 'PEDRO GOMES' },
  { value: '5', label: 'PONTA PORÃ' },
  { value: '21', label: 'RIBAS DO RIO PARDO' },
  { value: '18', label: 'RIO BRILHANTE' },
  { value: '22', label: 'SÃO GABRIEL DO OESTE' },
  { value: '25', label: 'SIDROLÂNDIA' },
  { value: '2', label: 'TRÊS LAGOAS' }
];
